import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { useTokenLogin } from '@/hooks/mutations/useLogin'
import { useGoogleLogin } from '@/hooks/mutations/useGoogleLogin'
import { Images } from '@/assets/Images'
import {
  googleOAuthConfig,
  generateCodeVerifier,
  generateCodeChallenge,
} from '@/config/google-oauth'
import { toast } from 'react-toastify'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { handleError } from '@/utils/helpers'

const isForDev =
  window.location.hostname === 'localhost' ||
  window.location.href.startsWith('https://momo-survey.tanksolutions.asia')

// TESTING ONLY - Replace with your actual tokens
interface TokenOption {
  id: string
  label: string
  token: string
}

const TOKEN_OPTIONS: TokenOption[] = [
  {
    id: '1',
    label: 'TRƯƠNG HUY HOÀNG - ITC - AI & Big Data - Software Engineer II',
    token:
      'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJqajA2Y2V4NnpIdGdrVHdpUmFUOXV4enJldXpzWkxnSUgydUpBcHlvNkdrIn0.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlRSxq_GoE5HIEhVWSBIT8OATkcgLSBJVEMgLSBBSSAmIEJpZyBEYXRhIC0gU29mdHdhcmUgRW5naW5lZXIgSUkiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJob2FuZy50cnVvbmczQG1zZXJ2aWNlLmNvbS52biIsImdpdmVuX25hbWUiOiJUUsavxqBORyBIVVkgSE/DgE5HIiwiZmFtaWx5X25hbWUiOiItIElUQyAtIEFJICYgQmlnIERhdGEgLSBTb2Z0d2FyZSBFbmdpbmVlciBJSSIsImVtYWlsIjoiaG9hbmcudHJ1b25nM0Btc2VydmljZS5jb20udm4iLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUNnOG9jSXI3SHQ3clB6ZmNkYjdlMkJjZ2xyOXlKN2I5bmUzWHpPZGZ2LWl2QkRHNUtneDdvOWY9czk2LWMifQ.VcbFVJjMO45Y65Z1DFzlKlmMR15ehQKn_V0dZlNxy4P2NZBpotesyedgsmg_V4P4pO-joV6_JyS6yVfi_5Sh-BHhE32B3Ln-mQzc_mXO7d6uaLojQmqAjDTYyfgKZ5OmysY_ttka1HYwYJgjNkOnltz5fpSFFtvio1scda0I8SP6TAK51djQ0IEg12L7wIObK1cTxMN5hEGyvTbC_-Ya43ekDzoMBY1AoVhaXEIF2ls9e25eVG0JeknICUCFxLP5XxpG0ShXxETeddONGKAJTOji6SfcHNMC4teH5CttaNVMEYxXpJimpUKgGCiUpXUp3Cz6rWSziXd2B-4KrTEhcQ',
  },
  {
    id: '2',
    label: 'TRẦN TRÚC THIÊN - BMC - Lead - Marketing Communications',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlRS4bqmTiBUUsOaQyBUSEnDik4gLSBCTUMgLSBMZWFkIC0gTWFya2V0aW5nIENvbW11bmljYXRpb25zIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGhpZW4udHJhbjE0QG1zZXJ2aWNlLmNvbS52biIsImdpdmVuX25hbWUiOiJUUuG6pk4gVFLDmkMgVEhJw4pOIiwiZmFtaWx5X25hbWUiOiItIEJNQyAtIExlYWQgLSBNYXJrZXRpbmcgQ29tbXVuaWNhdGlvbnMiLCJlbWFpbCI6InRoaWVuLnRyYW4xNEBtc2VydmljZS5jb20udm4iLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUNnOG9jSXI3SHQ3clB6ZmNkYjdlMkJjZ2xyOXlKN2I5bmUzWHpPZGZ2LWl2QkRHNUtneDdvOWY9czk2LWMifQ.8ElxsRsXiftIirQwNKJWMHCX1p67qthMvh6cpTX6o1o',
  },
  {
    id: '3',
    label: 'ĐỖ TIỂU THIÊN - ITC - AI & Big Data - Senior - AI Engineer',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IsSQ4buWIFRJ4buCVSBUSEnDik4gLSBJVEMgLSBBSSAmIEJpZyBEYXRhIC0gU2VuaW9yIC0gQUkgRW5naW5lZXIiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ0aGllbi5kbzFAbXNlcnZpY2UuY29tLnZuIiwiZ2l2ZW5fbmFtZSI6IsSQ4buWIFRJ4buCVSBUSEnDik4iLCJmYW1pbHlfbmFtZSI6Ii0gSVRDIC0gQUkgJiBCaWcgRGF0YSAtIFNlbmlvciAtIEFJIEVuZ2luZWVyIiwiZW1haWwiOiJ0aGllbi5kbzFAbXNlcnZpY2UuY29tLnZuIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0lyN0h0N3JQemZjZGI3ZTJCY2dscjl5SjdiOW5lM1h6T2Rmdi1pdkJERzVLZ3g3bzlmPXM5Ni1jIn0.q5bBxLbGIyoDPj_mrVSqyNCCJ1QdwkPXIreruCfrbSQ',
  },
  {
    id: '4',
    label: 'VÕ NGUYỄN PHƯƠNG HUYỀN - Payment Services - Product Growth & Marketing Specialist',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlbDlSBOR1VZ4buETiBQSMavxqBORyBIVVnhu4BOIC0gUGF5bWVudCBTZXJ2aWNlcyAtIFByb2R1Y3QgR3Jvd3RoICYgTWFya2V0aW5nIFNwZWNpYWxpc3QiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJodXllbi52bzFAbXNlcnZpY2UuY29tLnZuIiwiZ2l2ZW5fbmFtZSI6IlbDlSBOR1VZ4buETiBQSMavxqBORyBIVVnhu4BOIiwiZmFtaWx5X25hbWUiOiItIFBheW1lbnQgU2VydmljZXMgLSBQcm9kdWN0IEdyb3d0aCAmIE1hcmtldGluZyBTcGVjaWFsaXN0IiwiZW1haWwiOiJodXllbi52bzFAbXNlcnZpY2UuY29tLnZuIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0lyN0h0N3JQemZjZGI3ZTJCY2dscjl5SjdiOW5lM1h6T2Rmdi1pdkJERzVLZ3g3bzlmPXM5Ni1jIn0.xB9dF9RSex1vowLvgmJ3rIpgm3z8h_QYaV_LdTBch3M',
  },
  {
    id: '5',
    label: 'PHAN TRUNG TÍN - ITC - AI & Big Data - Senior - DevOps Engineer',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlBIQU4gVFJVTkcgVMONTiAtIElUQyAtIEFJICYgQmlnIERhdGEgLSBTZW5pb3IgLSBEZXZPcHMgRW5naW5lZXIiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ0aW4ucGhhbkBtc2VydmljZS5jb20udm4iLCJnaXZlbl9uYW1lIjoiUEhBTiBUUlVORyBUw41OIiwiZmFtaWx5X25hbWUiOiItIElUQyAtIEFJICYgQmlnIERhdGEgLSBTZW5pb3IgLSBEZXZPcHMgRW5naW5lZXIiLCJlbWFpbCI6InRpbi5waGFuQG1zZXJ2aWNlLmNvbS52biIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQ2c4b2NJcjdIdDdyUHpmY2RiN2UyQmNnbHI5eUo3YjluZTNYek9kZnYtaXZCREc1S2d4N285Zj1zOTYtYyJ9.RfrXcgpSaNrJdFY8s0SVCWBAi7C_wamg5RE4IsFA7GI',
  },
  {
    id: '6',
    label: 'NGUYỄN MẠNH TƯỜNG - BOM - Chief Executive Officer',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6Ik5HVVnhu4ROIE3huqBOSCBUxq_hu5xORyAtIEJPTSAtIENoaWVmIEV4ZWN1dGl2ZSBPZmZpY2VyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidHVvbmcubmd1eWVuQG1zZXJ2aWNlLmNvbS52biIsImdpdmVuX25hbWUiOiJOR1VZ4buETiBN4bqgTkggVMav4bucTkciLCJmYW1pbHlfbmFtZSI6Ii0gQk9NIC0gQ2hpZWYgRXhlY3V0aXZlIE9mZmljZXIiLCJlbWFpbCI6InR1b25nLm5ndXllbkBtc2VydmljZS5jb20udm4iLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUNnOG9jSXI3SHQ3clB6ZmNkYjdlMkJjZ2xyOXlKN2I5bmUzWHpPZGZ2LWl2QkRHNUtneDdvOWY9czk2LWMifQ.5yTJnZia1mKOGS2-hs8bvU7f25oHquI0VVqnZBMq5qI',
  },
  {
    id: '7',
    label: 'VŨ HƯƠNG THẢO - BMC - Head of Brand, Marketing & Communications',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NjE2NDI4OTQsImlhdCI6MTc2MTY0MjI5NCwiYXV0aF90aW1lIjoxNzYxNjQyMjk0LCJqdGkiOiIzMDE0NGVhYi0yZDU2LTRhZmEtODVhMS0zNDkwMDliMGU3ZDciLCJpc3MiOiJodHRwczovL29pZGMtZGV2Lm1zZXJ2aWNlLmlvL3JlYWxtcy9wYXJ0bmVyIiwic3ViIjoiNjJmN2RkYWMtNGEwOS00ZGU2LTliNjMtMjdiZjgwNTM2MjBmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibW0xNSIsIm5vbmNlIjoiZTkzODk2NjItOGQ3NC00ZGY3LWE4ZDQtYzg3NjcxYWU4OWIyIiwic2Vzc2lvbl9zdGF0ZSI6Ijg1NmY3MmQzLTE0ZGMtNDgxMS1hOTg2LTc2NDc0MWU1YzYyMiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teW1vbW8xNS5tb21vLnZuIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJzaWQiOiI4NTZmNzJkMy0xNGRjLTQ4MTEtYTk4Ni03NjQ3NDFlNWM2MjIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlbFqCBIxq_GoE5HIFRI4bqiTyAtIEJNQyAtIEhlYWQgb2YgQnJhbmQsIE1hcmtldGluZyAmIENvbW11bmljYXRpb25zIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGhhby52dTNAbXNlcnZpY2UuY29tLnZuIiwiZ2l2ZW5fbmFtZSI6IlbFqCBIxq_GoE5HIFRI4bqiTyIsImZhbWlseV9uYW1lIjoiLSBCTUMgLSBIZWFkIG9mIEJyYW5kLCBNYXJrZXRpbmcgJiBDb21tdW5pY2F0aW9ucyIsImVtYWlsIjoidGhhby52dTNAbXNlcnZpY2UuY29tLnZuIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0lyN0h0N3JQemZjZGI3ZTJCY2dscjl5SjdiOW5lM1h6T2Rmdi1pdkJERzVLZ3g3bzlmPXM5Ni1jIn0.jpvinyhJir7LLCKK3q7J1ZONSX4qmyQWxZNGilN1PIk',
  },
]

const LoginPage = () => {
  const navigate = useNavigate()
  const [selectedTokenId, setSelectedTokenId] = useState<string>(TOKEN_OPTIONS[0].id)
  const { mutate: tokenLogin, isPending } = useTokenLogin()
  const { mutate: googleLogin, isPending: isGooglePending } = useGoogleLogin()
  const googleProcessed = useRef(false)

  const handleGoogleLogin = async () => {
    try {
      const redirectUri = googleOAuthConfig.redirectUri

      // Generate random state for CSRF protection
      const state = crypto.randomUUID()
      sessionStorage.setItem('oauth_state', state)

      // Generate PKCE code verifier and challenge
      const codeVerifier = generateCodeVerifier()
      const codeChallenge = await generateCodeChallenge(codeVerifier)

      // Store code verifier for later use
      sessionStorage.setItem('pkce_code_verifier', codeVerifier)

      // Build Google authorization URL with PKCE
      const authUrl = new URL(googleOAuthConfig.authorizationEndpoint)
      authUrl.searchParams.set('client_id', googleOAuthConfig.clientId)
      authUrl.searchParams.set('redirect_uri', redirectUri)
      authUrl.searchParams.set('response_type', 'code')
      authUrl.searchParams.set('scope', googleOAuthConfig.scope)
      authUrl.searchParams.set('state', state)
      authUrl.searchParams.set('code_challenge', codeChallenge)
      authUrl.searchParams.set('code_challenge_method', 'S256')
      authUrl.searchParams.set('prompt', 'select_account')

      // Redirect to Google login page
      window.location.href = authUrl.toString()
    } catch (error) {
      console.error('Error initiating Google login:', error)
      handleError(error, { fallbackMessage: 'Lỗi khởi tạo đăng nhập Google' })
    }
  }

  // Handle Google OAuth authentication callback - extract code and send to backend
  useEffect(() => {
    // ⭐ CRITICAL: Prevent double execution (React 18 StrictMode)
    if (googleProcessed.current) {
      return
    }

    // Parse query string parameters
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')

    // Only process if we have both code and state
    if (!code || !state) {
      return
    }

    // Verify state parameter for CSRF protection
    const savedState = sessionStorage.getItem('oauth_state')
    if (state !== savedState) {
      toast.error('State mismatch - possible CSRF attack')
      return
    }

    // Get code verifier from session storage
    const codeVerifier = sessionStorage.getItem('pkce_code_verifier')
    if (!codeVerifier) {
      toast.error('Code verifier not found - please try again')
      return
    }

    // Mark as processing to prevent double calls
    googleProcessed.current = true

    // Clean up session storage
    sessionStorage.removeItem('oauth_state')
    sessionStorage.removeItem('pkce_code_verifier')

    // Use the same redirect URI as in googleLogin()
    const redirectUri = googleOAuthConfig.redirectUri

    googleLogin(
      {
        code,
        codeVerifier,
        redirectUri,
        state,
      },
      {
        onSuccess: () => {
          // Clean up URL params after successful login (remove code from browser history)
          window.history.replaceState({}, document.title, '/login')
          navigate('/')
        },
        onError: () => {
          // Reset the flag so user can retry
          googleProcessed.current = false
          // Clean up URL on error too
          window.history.replaceState({}, document.title, '/login')
        },
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // ⚠️ Empty dependency array to prevent re-runs!

  const handleTokenLogin = () => {
    const selectedToken = TOKEN_OPTIONS.find((t) => t.id === selectedTokenId)
    if (selectedToken) {
      tokenLogin(selectedToken.token, {
        onSuccess: () => {
          navigate('/')
        },
      })
    }
  }

  const selectedTokenLabel =
    TOKEN_OPTIONS.find((t) => t.id === selectedTokenId)?.label || 'Chọn token'

  return (
    <div className="relative flex items-center justify-center w-full min-h-screen">
      {/* Background with pattern - Fixed */}
      <div
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${Images.bg_with_pattern})`,
          backgroundSize: 'cover',
        }}
      />

      {/* Login Card */}
      <div
        className="relative z-1 rounded-[30px] shadow-2xl m-4 w-full sm:w-[900px] p-10"
        style={{
          backgroundImage: `url(${Images.background_paper})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        {/* Header Text */}
        <div className="mb-8 text-center">
          <h1 className="text-[30px] md:text-[55px] md:leading-[59px] leading-[40px] font-momo-trust-display">
            <span className="text-primary">MoMo Tôi Đó</span>
            <br />
          </h1>
          <h2 className="mt-2 text-[20px] md:text-[32px] md:leading-[39px] leading-[29px] font-medium">
            <span className="text-black">Nơi những công việc không tên </span>
            <br />
            <span className="text-black">
              của bạn và đồng nghiệp được viết ra cùng với{' '}
              <span className="text-primary inline-flex items-center">
                AI
                <img src={Images.icon_blink} alt="sparkle" className="w-auto h-5" />
              </span>
            </span>
          </h2>
        </div>

        {/* Login Buttons */}
        <div className="flex flex-col items-center gap-4">
          {/* Token Selection - Only visible in dev environments */}
          {isForDev && (
            <>
              <div className="flex flex-col items-center w-full max-w-md gap-2">
                <label className="text-sm font-medium text-gray-700">Chọn tài khoản:</label>
                <Select value={selectedTokenId} onValueChange={setSelectedTokenId}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Chọn token">
                      <span className="block truncate">{selectedTokenLabel}</span>
                    </SelectValue>
                  </SelectTrigger>
                  <SelectContent>
                    {TOKEN_OPTIONS.map((option) => (
                      <SelectItem key={option.id} value={option.id}>
                        <span className="block truncate">{option.label}</span>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* Token Login Button */}
              <Button
                onClick={handleTokenLogin}
                disabled={isPending || isGooglePending}
                className="btn-primary w-fit"
              >
                {isPending ? 'Đang đăng nhập...' : 'Đăng nhập để kể'}
              </Button>

              <span className="block text-sm text-center text-gray-500">hoặc</span>
            </>
          )}

          {/* Google Login Button */}
          <Button
            type="button"
            onClick={handleGoogleLogin}
            disabled={isPending || isGooglePending}
            className="btn-primary w-fit"
          >
            {isGooglePending ? 'Đang đăng nhập...' : 'Đăng nhập để bắt đầu'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
